import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import Section from "./Section";

const packages = [
    {
        name: "flutter_telebirr",
        registry: "pub.dev",
        description:
            "Payment integration package for telebirr: fetch a payment URL and initiate transactions with app credentials.",
        link: "https://pub.dev/packages/flutter_telebirr",
    },
    {
        name: "flutter_telegram_gateway",
        registry: "pub.dev",
        description:
            "Easy interaction with the Telegram Gateway API: send verification messages, verify codes, check status.",
        link: "https://pub.dev/packages/flutter_telegram_gateway",
    },
    {
        name: "third_party_login",
        registry: "pub.dev",
        description:
            "One simple API for Google, Facebook, Apple, and phone sign-in: skip building each integration by hand.",
        link: "https://pub.dev/packages/third_party_login",
    },
    {
        name: "theme_debug_overlay",
        registry: "pub.dev",
        description:
            "A draggable, animated overlay to toggle ThemeMode at runtime: debug-only, zero cost in release.",
        link: "https://pub.dev/packages/theme_debug_overlay",
    },
    {
        name: "cleanwave",
        registry: "npm",
        description:
            "High-performance cleanup CLI for app and backend projects: reclaim gigabytes of build artifacts in seconds.",
        link: "https://www.npmjs.com/package/cleanwave",
    },
];

function PackageCard({ pkg }) {
    return (
        <a
            href={pkg.link}
            target="_blank"
            rel="noreferrer"
            className="group relative block border-2 border-black/15 dark:border-white/20 bg-white/85 dark:bg-black/60 hover:border-black dark:hover:border-white transition-colors p-6 focus-visible:z-10"
        >
            <div className="flex items-start justify-between gap-3">
                <h3 className="font-display text-lg font-semibold text-black dark:text-white break-all">
                    {pkg.name}
                </h3>
                <span className="shrink-0 text-[10px] font-bold uppercase tracking-wider px-2 py-1 border border-stone-300 dark:border-stone-600 text-stone-700 dark:text-stone-300">
                    {pkg.registry}
                </span>
            </div>
            <p className="mt-3 text-sm text-stone-600 dark:text-stone-400 leading-relaxed">{pkg.description}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs font-bold uppercase tracking-wider text-black dark:text-white">
                View package
                <FiArrowUpRight className="shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden />
            </span>
        </a>
    );
}

export default function OpenSource() {
    return (
        <Section id="open-source" subtitle="Published packages" title="Open source">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {packages.map((pkg) => (
                    <PackageCard key={pkg.name} pkg={pkg} />
                ))}
            </div>
        </Section>
    );
}
